module.exports = __webpack_public_path__ + "static/crowdfunding-featured-9e1f0dff3a031d5152c2baf6e9783179.png";